import { MARKETS as n } from "../hooks/use-market.js";
const a = "en-gb", i = (t) => {
  const e = t.split("-");
  return e[0] = e[0].toLowerCase(), e[1] && (e[1] = e[1].toUpperCase()), e.join("-");
};
function s(t) {
  if (!/[a-z]{2,2}-[a-z]{2,2}/i.test(t))
    return !1;
  try {
    const e = Intl.getCanonicalLocales(t);
    return e.length === 0 ? !1 : e[0];
  } catch {
    return !1;
  }
}
function f(t) {
  return new Intl.Locale(t);
}
function l({ locale: t, locales: e }) {
  return typeof t != "string" || s(t) === !1 || !Array.isArray(e) || e.length === 0 ? !1 : e.some((o) => o.toLowerCase() === t.toLowerCase());
}
const L = (t) => (t ?? window.location.pathname).split("/").filter(Boolean)[0] ?? a, u = (t) => {
  if (!t) return n.REST_OF_WORLD;
  const r = t.split("-")[1];
  return r ? r.toUpperCase() === n.NORWEGIAN ? n.NORWEGIAN : n.REST_OF_WORLD : n.REST_OF_WORLD;
};
export {
  i as formatLocale,
  s as getCanonicalLocale,
  L as getLocaleFromPathname,
  u as getMarketFromLocale,
  l as isValidLocale,
  f as parseLocale
};
